<template>
	<div>
		<div>
			<el-form>
				<el-form-item style="position: relative;">
					<el-select v-model="queryFilter.id" size="mini" class="selectStyle" clearable>
						<el-option v-for="item in stores" :key="item.id" :label="item.title"
							:value="item.id"></el-option>
					</el-select>
					<el-date-picker class="selectStyle" style="width: 250px" v-model="queryFilter.month"
						value-format="yyyy-MM" :clearable="clear" type="month" size="mini">
					</el-date-picker>
					<el-button type="primary" size="mini" @click="workerPerformance">筛选</el-button>
					<el-button type="primary" size="mini" @click="exports">导出</el-button>
					<div style="position: absolute; left:95%; top:10px;">
						<el-button type="primary" size="mini" v-if="tableEdit" @click="editTable">保存</el-button>
						<el-button type="primary" size="mini" v-else @click="tableEdit = true">编辑</el-button>
					</div>
				</el-form-item>
			</el-form>
		</div>
		<div>
			<el-table align="center" :data="performance" width="100%">
				<el-table-column prop="storeName" label="门店" min-width="100" align="center">
					<template slot-scope="scope">
						{{ scope.row.storeName ?scope.row.storeName :'/' }}
					</template>
				</el-table-column>
				<el-table-column prop="name" label="发型师" min-width="80" align="center">
					<template slot-scope="scope">
						{{ scope.row.name }}
					</template>
				</el-table-column>
				<el-table-column prop="levelTitle" label="发型师等级" min-width="100" align="center">
					<template slot-scope="scope">
						{{ scope.row.levelTitle }}
					</template>
				</el-table-column>
				<el-table-column prop="baseSalary" label="底薪" min-width="80" align="center">
					<template slot-scope="scope">
						{{ (scope.row.baseSalary/100).toFixed(2) }}
					</template>
				</el-table-column>
				<el-table-column label="迟到(min/元)" min-width="120" align="center">
					<template slot-scope="scope">
						{{ scope.row.lateTotal }} / {{ (scope.row.diffOfLate/100).toFixed(2) }}
					</template>
				</el-table-column>
				<el-table-column label="早退(min/元)" min-width="120" align="center">
					<template slot-scope="scope">
						{{ scope.row.advanceTotal }} / {{ (scope.row.diffOfAdvance/100).toFixed(2) }}
					</template>
				</el-table-column>
				<el-table-column prop="actualCount" label="缺卡" min-width="80" align="center">
					<template slot-scope="scope">
						{{ scope.row.actualCount }}
					</template>
				</el-table-column>
				<el-table-column prop="askforCount" label="请假" min-width="80" align="center">
					<template slot-scope="scope">
						{{ scope.row.askforCount }}
					</template>
				</el-table-column>
				<el-table-column prop="repairCount" label="补卡" min-width="80" align="center">
					<template slot-scope="scope">
						{{ scope.row.repairCount }}
					</template>
				</el-table-column>
				<el-table-column prop="isAllCheck" label="全勤" min-width="80" align="center">
					<template slot-scope="scope">
						{{ scope.row.isAllCheck ?'是' :'否' }}
					</template>
				</el-table-column>
				<el-table-column prop="monthMerits" label="月度绩效考核" min-width="120" align="center">
					<template slot-scope="scope">
						<el-input-number class="number_width" size="mini" v-if="tableEdit" :precision="2" :min="0"
							:controls="numberControl" v-model="scope.row.monthMerits"></el-input-number>
						<span v-else>{{ (scope.row.monthMerits).toFixed(2) }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="monthBuff" label="月度提成" min-width="80" align="center">
					<template slot-scope="scope">
						{{ (scope.row.monthCommission/100).toFixed(2) }}
					</template>
				</el-table-column>
				<el-table-column prop="commentReward" label="评论奖励" min-width="80" align="center">
					<template slot-scope="scope">
						{{ (scope.row.commentReward/100).toFixed(2) }}
					</template>
				</el-table-column>
				<el-table-column prop="monthSalary" label="当月薪资" min-width="80" align="center">
					<template slot-scope="scope">
						{{ (scope.row.monthSalary/100).toFixed(2) }}
					</template>
				</el-table-column>
			</el-table>
			<div style="margin: 10px 30%">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page.sync="queryFilter.pageNum" :page-sizes="[10, 20, 50]"
					:page-size="queryFilter.pageSize" layout="total, sizes, prev, pager, next"
					:total="queryFilter.total">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		url
	} from "../../../utils/index.js"
	export default {
		data() {
			return {
				url: url(),
				clear: false,
				queryFilter: {
					id: undefined,
					month: new Date().getUTCFullYear() + '-' + (new Date().getMonth()),
					pageNum: 1,
					pageSize: 10,
					total: 0,
				},
				numberControl: false,
				stores: [],
				performance: [],
				tableEdit: false,
			}
		},
		mounted() {
			this.getStores();
			this.workerPerformance();
		},
		methods: {
			editTable() {
				let data = [];
				this.performance.map(ele => {
					data.push({
						id: ele.id,
						monthMerits: ele.monthMerits,
					});
				});
				this.$http.post("dWorker/setMonthMerits", JSON.stringify(data)).then(res => {
					if (res.body.code == 200) {
						this.workerPerformance()
						this.tableEdit = false;
						this.$message.success("保存成功");
					} else {
						this.$message.error(res.body.msg);
					}
				});
			},
			exports() {
				let str = "dWorker/export?month=" + this.queryFilter.month;
				if (this.queryFilter.id) str += "&id=" + this.queryFilter.id;
				window.location.assign(this.url + str);
			},
			handleSizeChange(val) {
				if (this.tableEdit) {
					this.$confirm('切换 条目/页数 需先保存当前页数据', '温馨提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.queryFilter.pageSize = val;
						this.editTable();
					});
				} else {
					this.queryFilter.pageSize = val;
					this.workerPerformance();
				}
			},
			handleCurrentChange(val) {
				if (this.tableEdit) {
					this.$confirm('切换 条目/页数 需先保存当前页数据', '温馨提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.queryFilter.pageNum = val;
						this.editTable();
					});
				} else {
					this.queryFilter.pageNum = val;
					this.workerPerformance();
				}
			},
			getStores() {
				this.$http.get("store/list").then(res => {
					this.stores = res.body.data
				})
			},
			workerPerformance() {
				this.$http.post('dWorker/performance', JSON.stringify(this.queryFilter)).then(res => {
					this.performance = res.body.data;
					this.queryFilter.total = res.body.total;
				});
			},
		}
	}
</script>

<style lang="less" scoped>
	.selectStyle {
		width: 120px;
		margin-right: 15px;
	}

	.number_width {
		width: 80px;
	}
</style>